import {
  ListAccountVerificationsResult,
  ListGuestCheckoutVerificationsResult,
  ListMarketingSMSProgramsResult,
  ListOrderConfirmationsResult,
  ListPasswordlessAuthenticationsResult,
  SMSTotalsByTypeResult,
} from '../sms-reports.type';

export const getSMSTotalsByTypeResult: SMSTotalsByTypeResult = {
  segmentsTotal: 12,
  smsTotal: 20,
};

/**
 * Returns totals matching the requested SMS type so each report tab's summary
 * header shows distinct values. Each tab passes a single fixed `type`.
 */
export const getSMSTotalsByType = (type: string): SMSTotalsByTypeResult => {
  if (type?.includes('MARKETING')) {
    return { segmentsTotal: 75, smsTotal: 80 };
  }
  if (type?.includes('TRANSACTIONAL')) {
    return { segmentsTotal: 357, smsTotal: 305 };
  }
  if (type?.includes('GUEST_CHECKOUT_VERIFICATION')) {
    return { segmentsTotal: 40, smsTotal: 35 };
  }
  if (type?.includes('PASSWORDLESS_AUTH')) {
    return { segmentsTotal: 63, smsTotal: 58 };
  }
  return getSMSTotalsByTypeResult;
};

export const marketingSmsPrograms: ListMarketingSMSProgramsResult = {
  marketingSmsPrograms: [
    {
      communication: 'test message sms dashboard',
      communicationType: 'MESSAGE',
      endDate: '2024-12-24T00:00:00',
      percentDelivered: 0.21428572,
      segmentsSent: 28,
      smsDelivered: 6,
      smsSent: 28,
      startDate: '2024-09-26T00:00:00',
    },
    {
      communication: '9111 - 13 -Ac - Test 8',
      communicationType: 'MESSAGE',
      percentDelivered: 61.083333336,
      segmentsSent: 12,
      smsDelivered: 1,
      smsSent: 12,
      startDate: '2024-10-14T00:00:00',
    },
    {
      communication: '10% vanilla test modifier toast offer - 08/06',
      communicationType: 'OFFER',
      percentDelivered: 98.25,
      segmentsSent: 8,
      smsDelivered: 2,
      smsSent: 8,
      startDate: '2024-08-06T00:00:00',
    },
    {
      communication: 'Survey Test 9/4',
      communicationType: 'MESSAGE',
      percentDelivered: 0.16666667,
      segmentsSent: 6,
      smsDelivered: 1,
      smsSent: 6,
      startDate: '2024-09-04T00:00:00',
    },
    {
      communication: 'oct 2 offer 33',
      communicationType: 'OFFER',
      percentDelivered: 0,
      segmentsSent: 3,
      smsDelivered: 0,
      smsSent: 3,
      startDate: '2024-10-02T00:00:00',
    },
    {
      communication: 'oct 2 offer 2',
      communicationType: 'OFFER',
      percentDelivered: 0.33333334,
      segmentsSent: 3,
      smsDelivered: 1,
      smsSent: 3,
      startDate: '2024-10-02T00:00:00',
    },
    {
      communication: 'oct 1 SMS test',
      communicationType: 'MESSAGE',
      percentDelivered: 0.33333334,
      segmentsSent: 3,
      smsDelivered: 1,
      smsSent: 3,
      startDate: '2024-10-02T00:00:00',
    },
    {
      communication: 'oct 1 SMS test offer',
      communicationType: 'OFFER',
      percentDelivered: 0,
      segmentsSent: 3,
      smsDelivered: 0,
      smsSent: 3,
      startDate: '2024-10-02T00:00:00',
    },
    {
      communication: 'Pre Atlas Shareable Message',
      communicationType: 'MESSAGE',
      percentDelivered: 0,
      segmentsSent: 2,
      smsDelivered: 0,
      smsSent: 2,
      startDate: '2024-03-29T00:00:00',
    },
    {
      communication: 'Private message 08/16',
      communicationType: 'MESSAGE',
      percentDelivered: 0,
      segmentsSent: 1,
      smsDelivered: 0,
      smsSent: 1,
      startDate: '2024-08-16T00:00:00',
    },
  ],
  paging: {
    total: 16,
    count: 10,
    totalPages: 1,
    currentPage: 0,
  },
};

export const orderConfirmations: ListOrderConfirmationsResult = {
  orderConfirmations: [
    {
      locationId: '5c46f32d-8538-4580-9a73-4cb903eae687',
      locationName: 'Test Location SW 3',
      percentDelivered: 0,
      segmentsCountDeliveredTotal: 0,
      segmentsSent: 3,
      smsDelivered: 0,
      smsDeliveredTotal: 0,
      smsSent: 3,
    },
    {
      locationId: '5100f121-a825-451d-b86e-b4e3e314984f',
      locationName: 'Doordash orders - React Dashboard setup',
      percentDelivered: 52.8333333,
      segmentsCountDeliveredTotal: 10,
      segmentsSent: 12,
      smsDelivered: 10,
      smsDeliveredTotal: 10,
      smsSent: 12,
    },
    {
      locationId: '560894f4-84a8-4f56-88ef-5e6f623d0859',
      locationName: 'QU Testing Store -QA',
      percentDelivered: 91.4375,
      segmentsCountDeliveredTotal: 13,
      segmentsSent: 29,
      smsDelivered: 7,
      smsDeliveredTotal: 7,
      smsSent: 16,
    },
    {
      locationId: '955327bb-d8fd-4212-8bfc-e0872ebf27d7',
      locationName: 'Gags - New location for Payments',
      percentDelivered: 0.22222222,
      segmentsCountDeliveredTotal: 2,
      segmentsSent: 9,
      smsDelivered: 2,
      smsDeliveredTotal: 2,
      smsSent: 9,
    },
    {
      locationId: '66955a44-3a27-4720-9878-918d502c788a',
      locationName: 'FENWAY - Balsamic Toast Store',
      percentDelivered: 0.44230768,
      segmentsCountDeliveredTotal: 46,
      segmentsSent: 104,
      smsDelivered: 46,
      smsDeliveredTotal: 46,
      smsSent: 104,
    },
    {
      locationId: '957d4843-07e2-4831-9c94-438bdc9de026',
      locationName: 'Fenway - QA  P1 Test Store',
      percentDelivered: 0.44444445,
      segmentsCountDeliveredTotal: 24,
      segmentsSent: 53,
      smsDelivered: 20,
      smsDeliveredTotal: 20,
      smsSent: 45,
    },
    {
      locationId: '6367bbe2-4ed0-4c4a-98be-3d8f430f1384',
      locationName: "SpotOn QA - Don't Edit",
      percentDelivered: 0,
      segmentsCountDeliveredTotal: 0,
      segmentsSent: 22,
      smsDelivered: 0,
      smsDeliveredTotal: 0,
      smsSent: 22,
    },
    {
      locationId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      locationName: "Fenway - QA  (Don't Edit) - Original",
      percentDelivered: 0.29100528,
      segmentsCountDeliveredTotal: 85,
      segmentsSent: 258,
      smsDelivered: 55,
      smsDeliveredTotal: 55,
      smsSent: 189,
    },
    {
      locationId: '06f3898b-3148-4ea4-a644-a129a35270d9',
      locationName: 'Seattle - QU (QA Use)',
      percentDelivered: 0.65217394,
      segmentsCountDeliveredTotal: 30,
      segmentsSent: 46,
      smsDelivered: 15,
      smsDeliveredTotal: 15,
      smsSent: 23,
    },
    {
      locationId: '609bface-afe5-4510-b928-a8d7580235d3',
      locationName: 'Test new fenway location',
      percentDelivered: 0.4375,
      segmentsCountDeliveredTotal: 40,
      segmentsSent: 84,
      smsDelivered: 14,
      smsDeliveredTotal: 14,
      smsSent: 32,
    },
    {
      locationId: '952e1839-75f2-4d4b-9949-3760579583b8',
      locationName: 'Tower Sq (DON"T EDIT)',
      percentDelivered: 0.50574714,
      segmentsCountDeliveredTotal: 44,
      segmentsSent: 87,
      smsDelivered: 44,
      smsDeliveredTotal: 44,
      smsSent: 87,
    },
    {
      locationId: '747f00fe-1285-4001-8f5d-962ead578e9b',
      locationName: 'Regression Testing Store',
      percentDelivered: 0.26666668,
      segmentsCountDeliveredTotal: 4,
      segmentsSent: 15,
      smsDelivered: 4,
      smsDeliveredTotal: 4,
      smsSent: 15,
    },
    {
      locationId: '9fa23d16-6011-48d7-ae8d-7fc682223200',
      locationName: "Fenway - QA (Don't Edit) - Original Related 01",
      percentDelivered: 0.25,
      segmentsCountDeliveredTotal: 1,
      segmentsSent: 8,
      smsDelivered: 1,
      smsDeliveredTotal: 1,
      smsSent: 4,
    },
    {
      locationId: '93e97928-de13-43d2-9f6c-1a5868bfe6c5',
      locationName: "Fenway - QA  (Don't Edit) - Original",
      percentDelivered: 0,
      segmentsCountDeliveredTotal: 0,
      segmentsSent: 1,
      smsDelivered: 0,
      smsDeliveredTotal: 0,
      smsSent: 1,
    },
    {
      locationId: '8c1c0289-d32b-4e28-836c-312197fda3d0',
      locationName: 'Doordash orders (DoNot change ANY -configurations)',
      percentDelivered: 0.25,
      segmentsCountDeliveredTotal: 4,
      segmentsSent: 10,
      smsDelivered: 1,
      smsDeliveredTotal: 1,
      smsSent: 4,
    },
    {
      locationId: '354055a5-c5ee-479d-bcd1-5c906a09efbf',
      locationName: 'New fenway Demo Location  6',
      percentDelivered: 1,
      segmentsCountDeliveredTotal: 3,
      segmentsSent: 3,
      smsDelivered: 1,
      smsDeliveredTotal: 1,
      smsSent: 1,
    },
    {
      locationId: 'e410319a-d820-4da2-b08e-5e3242188a28',
      locationName: 'Toronto OTTER (QA Use)',
      percentDelivered: 0.6666667,
      segmentsCountDeliveredTotal: 3,
      segmentsSent: 4,
      smsDelivered: 2,
      smsDeliveredTotal: 2,
      smsSent: 3,
    },
  ],
};

export const guestCheckoutVerifications: ListGuestCheckoutVerificationsResult =
  {
    guestCheckoutVerifications: [
      {
        locationId: '5c46f32d-8538-4580-9a73-4cb903eae687',
        locationName: 'Test Location SW 3',
        percentDelivered: 0,
        segmentsCountDeliveredTotal: 0,
        segmentsSent: 5,
        smsDelivered: 0,
        smsDeliveredTotal: 0,
        smsSent: 5,
      },
      {
        locationId: '5100f121-a825-451d-b86e-b4e3e314984f',
        locationName: 'Doordash orders - React Dashboard setup',
        percentDelivered: 0.8,
        segmentsCountDeliveredTotal: 16,
        segmentsSent: 20,
        smsDelivered: 16,
        smsDeliveredTotal: 16,
        smsSent: 20,
      },
      {
        locationId: '560894f4-84a8-4f56-88ef-5e6f623d0859',
        locationName: 'QU Testing Store -QA',
        percentDelivered: 0.5,
        segmentsCountDeliveredTotal: 5,
        segmentsSent: 10,
        smsDelivered: 5,
        smsDeliveredTotal: 5,
        smsSent: 10,
      },
    ],
  };

export const accountVerifications: ListAccountVerificationsResult = {
  accountVerifications: [
    {
      percentDelivered: 0.1,
      segmentsSent: 20,
      smsDelivered: 2,
      smsSent: 20,
    },
  ],
};

// Mock data mirroring account verification (same shape, confirmed by the BE).
export const passwordlessAuthentications: ListPasswordlessAuthenticationsResult =
  {
    passwordlessAuthentications: [
      {
        percentDelivered: 0.9,
        segmentsSent: 63,
        smsDelivered: 52,
        smsSent: 58,
      },
    ],
  };
